// SSOButtons.jsx
import {useEffect } from 'react';
import PropTypes from "prop-types";

import { useIntl } from "@edx/frontend-platform/i18n";
import { getConfig } from "@edx/frontend-platform";
import { Form, StatefulButton } from '@edx/paragon';

import messages from "../messages";

import ThirdPartyAuth from "../components/ThirdPartyAuth";
import ThirdPartyAuthAlert from '../../common-components/ThirdPartyAuthAlert';
import { EnvelopeIcon } from "@phosphor-icons/react";

import { REGISTER_PAGE } from "../../data/constants";

const RegistrationMethod = ({
  handleGoToNextStep,
  handleInstitutionLogin,
  thirdPartyAuthApiStatus,
  providers,
  secondaryProviders,
  currentProvider,
}) => {
  const { formatMessage } = useIntl();

  const hasProvider = Boolean(currentProvider);

  useEffect(() => {
    if (hasProvider) {
      handleGoToNextStep();
    }
  }, [hasProvider]);

  if (hasProvider) {
    return null;
  }

  return (
    <div className="intro-page intro-background flex-center-column">
      <h1 className="text-black form-header">
        {formatMessage(messages["intro.page.title"], { enter: <br /> })}
      </h1>
      <p className="mt-2 mb-4 regular-text text-black intro-subtitle">
        {formatMessage(messages["intro.page.subtitle"])}
      </p>
      <ThirdPartyAuthAlert
        currentProvider={currentProvider}
        providers={providers}
        platformName={getConfig().SITE_NAME}
        referrer={REGISTER_PAGE}
      />
      <ThirdPartyAuth
        currentProvider={currentProvider}
        providers={providers}
        secondaryProviders={secondaryProviders}
        handleInstitutionLogin={handleInstitutionLogin}
        thirdPartyAuthApiStatus={thirdPartyAuthApiStatus}
      />
      <StatefulButton
        id="next-step"
        icons={{ default: <EnvelopeIcon size={24} className="mr-2" /> }}
        name="next-step"
        type="button"
        onClick={handleGoToNextStep}
        className="flex-center-column mb-2 btn-onboarding"
        labels={{
          default: formatMessage(messages["intro.page.button.text"]),
        }}
      />
    </div>
  );
};

RegistrationMethod.propTypes = {
  providers: PropTypes.array.isRequired,
  secondaryProviders: PropTypes.array,
  currentProvider: PropTypes.string,
  handleInstitutionLogin: PropTypes.func.isRequired,
  thirdPartyAuthApiStatus: PropTypes.string,
  handleGoToNextStep: PropTypes.func.isRequired,
};

RegistrationMethod.defaultProps = {
  secondaryProviders: [],
  thirdPartyAuthApiStatus: "",
  currentProvider: null,
};

export default RegistrationMethod;
